import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserCardContentService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getByUserCardId(userCard: bigint): Observable<any> {
    return this.http.get(`${this.apiUrl}/content/byCard/${userCard}`);
  }

  getDocument(document: string): Observable<any> {
    const encodedDocumentName = encodeURIComponent(document);
    return this.http.get(`${this.apiUrl}/content/get/${encodedDocumentName}?t=${Date.now()}`, {responseType: 'blob'})
  }

}
